module.exports = fox._r("images/bg/bg_body.jpg", __webpack_public_path__ + "images/bg/bg_body.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/bg_body.jpg
// module id = 993
// module chunks = 4